import React, { useEffect, useState } from 'react';
import { Table, Card, Button } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { getRequest, ResponseDataType } from 'api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

interface HomeroomClass {
    classYearId: number;
    classId: number;
    classLevel: string;
    className: string;
    schoolId: number;
    classOrder: number;
}

export const HomeroomClassList = () => {
    const [homeroomClasses, setHomeroomClasses] = useState<HomeroomClass[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    useEffect(() => {
        const customerId = localStorage.getItem('uid');
        if (customerId) {
            fetchTeacherIdAndClasses(customerId);
        } else {
            toast.error('Không tìm thấy customerId');
        }
    }, []);

    const fetchTeacherIdAndClasses = async (customerId: string) => {
        try {
            // Gọi API lấy teacherId từ customerId
            const teacherRes = await getRequest(`/cms/teacher/get-teacher-info-by-customer-id?customerId=${customerId}`);
            const teacherId = teacherRes?.info?.teacherId;

            if (!teacherId) {
                toast.error('Không tìm thấy giáo viên tương ứng');
                return;
            }

            // Gọi API lấy lớp chủ nhiệm bằng teacherId
            fetchHomeroomClasses(teacherId);
        } catch (error) {
            toast.error('Lỗi khi lấy thông tin giáo viên');
        }
    };

    const fetchHomeroomClasses = async (teacherId: string | number) => {
        setLoading(true);
        const url = `/cms/teacher/${teacherId}/get-classYear-by-homeroom-teacher?status=1`;

        try {
            const response: ResponseDataType<HomeroomClass[]> = await getRequest(url);
            if (response?.code === 200 && Array.isArray(response.info)) {
                setHomeroomClasses(response.info);
            } else {
                toast.error(response?.msg || 'Không thể tải danh sách lớp chủ nhiệm');
            }
        } catch (error) {
            toast.error('Lỗi khi gọi API lớp chủ nhiệm');
        } finally {
            setLoading(false);
        }
    };

    const columns: ColumnsType<HomeroomClass> = [
        { title: 'Tên lớp', dataIndex: 'className', key: 'className', align: 'center' },
        { title: 'Khối', dataIndex: 'classLevel', key: 'classLevel', align: 'center' },
        { title: 'Thứ tự lớp', dataIndex: 'classOrder', key: 'classOrder', align: 'center' },
        { title: 'Mã trường', dataIndex: 'schoolId', key: 'schoolId', align: 'center' },
        {
            title: 'Hành động',
            key: 'action',
            align: 'center',
            render: (_, record) => (
                <Button type="link" onClick={() => navigate(`/homeroom-class-detail/${record.classYearId}`)}>
                    Xem chi tiết
                </Button>
            ),
        },
    ];

    return (
        <Card title="Danh sách lớp chủ nhiệm" style={{ marginTop: 16 }}>
            <Table
                columns={columns}
                dataSource={homeroomClasses}
                rowKey="classYearId"
                loading={loading}
                pagination={false}
                locale={{ emptyText: 'Không có lớp chủ nhiệm nào' }}
            />
        </Card>
    );
};
